<script lang="ts" setup>
import OrderRefs from "@/components/order/OrderRefs.vue";
import OrderNote from "@/views/trips/monitor/components/OrderNote.vue";
import OrderTemperatures from "@/components/order/OrderTemperatures.vue";
import { useAppStore } from "@/store/app.store";
import type { TripMonitorOrder } from "@/api/trips/dto/trip-monitor";
import { computed } from "vue";
import BrokerTeamIcon from "@/components/icons/BrokerTeamIcon.vue";
import UnderTrackingIcon from "@/components/icons/UnderTrackingIcon.vue";
import HazmatCommodityIcon from "@/components/icons/HazmatCommodityIcon.vue";

const appStore = useAppStore();

const props = defineProps<{
  order: TripMonitorOrder;
}>();

const dispatcher = computed(() => {
  return appStore.dispatchers.find((dispatcher) => dispatcher.id === props.order.bookedBy);
});
</script>

<template>
  <div class="d-flex align-center">
    <div class="d-flex align-center font-size-14 font-weight-500 text-grey-darken-3">
      <div class="text-grey-darken-3 mr-1">Ref:</div>
      <order-refs :refs="order.refNumbers" />
    </div>

    <router-link
      :to="{ name: 'order-view', params: { id: order.id } }"
      class="text-decoration-none text-primary ml-6 font-size-14"
      data-qa="order-number"
      target="_blank"
    >
      Order #{{ order.number }}
    </router-link>

    <div class="ml-1 d-flex items-center">
      <broker-team-icon :size="14" :team-for-broker="order.teamForBroker" class="ml-2" color="grey-darken-2" />

      <under-tracking-icon :size="14" :under-tracking="order.underTracking" class="ml-2" color="blue-grey" />

      <order-temperatures
        :protect-from-freezing="order.protectFromFreezing"
        :temperatures="order.temperatures"
        class="ml-2"
      />

      <hazmat-commodity-icon :hazmat-commodity="order.hazmat" :size="14" class="ml-2" />
    </div>

    <div class="d-flex align-center ml-6 font-size-12 font-weight-500">
      <div class="text-grey-darken-1">Bill to:</div>
      <router-link
        :to="{ name: 'customer-edit', params: { id: order.customer.id } }"
        class="text-primary ml-1 text-decoration-none"
        data-qa="order-customer"
        target="_blank"
      >
        {{ order.customer.name }}
      </router-link>
    </div>

    <div class="d-flex align-center ml-6 font-size-12 font-weight-500">
      <div class="text-grey-darken-1 mr-1">Booked by:</div>
      <span class="text-primary">{{ dispatcher?.name || "-" }}</span>
    </div>

    <order-note :order="order" />
  </div>
</template>

<style lang="scss" scoped>
@import "@/assets/style/color";

.ref-number {
  span {
    transition: all ease-in-out 200ms;
    cursor: pointer;
  }

  &:hover {
    span {
      color: $primary !important;
    }
  }
}
</style>
